export enum PlayerEventApiEnum {
    PlayerInit = 'video-player-loaded',
    SceneStart = 'video-player-scene-begin',
    SceneEnd = 'video-player-scene-played',
    FormSubmitted = 'video-player-form-submit',
    ButtonClicked = 'video-player-button-clicked',
    VideoCompleted = 'video-player-video-ended',
    VideoUserPaused = 'video-player-user-paused',
    VideoUserResumed = 'video-player-user-resumed',
    OverlayShow = 'video-player-overlay-show',
    OverlayHide = 'video-player-overlay-hide',
    VideoProgress = 'video-player-progress'
}
